/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { isNone } from '@ember/utils';
import { inject as service } from '@ember/service';
import Refinement from 'cio/app-models/conditions/refinement';
import ScreenviewCondition from 'cio/app-models/conditions/screenview';
import AuthService from 'cio/services/auth';

interface CioConditionEditorScreenviewArgs {
  // backwards compat
  classNames: string;
  condition: ScreenviewCondition;
  allowMessageWildcardSelection?: boolean;
  allowInParentWildcardSelection?: boolean;
  depth: number;
  inverseOptions: { value: boolean; label: string }[];
  anyScreenOptions: { value: boolean; label: string }[];
  actionItems: { value: boolean; label: string }[];
  customerItems: { value: boolean; label: string }[];
  canDuplicate?: boolean;
  changetype: () => unknown;
  onRemove: () => unknown;
  onDuplicate?: () => unknown;
  disabled: boolean;
}

export default class CioConditionEditorScreenview extends Component<CioConditionEditorScreenviewArgs> {
  @service auth!: AuthService;

  get inverseOptions() {
    return (
      this.args.inverseOptions ?? [
        { value: false, label: 'has been viewed' },
        { value: true, label: 'has not been viewed' },
      ]
    );
  }

  get anyScreenOptions() {
    return (
      this.args.anyScreenOptions ?? [
        { value: true, label: 'any screen' },
        { value: false, label: 'with name matching' },
      ]
    );
  }

  @computed('args.condition.refinement')
  get isRefined() {
    let { refinement } = this.args.condition;
    return !isNone(refinement);
  }

  @computed('args.condition.errors')
  get errors() {
    let { errors } = this.args.condition;
    return Object.values(errors).reduce((err: string[], msg: string) => err.concat(msg), []);
  }

  @action
  addRefinement() {
    this.args.condition.set('refinement', Refinement.create());
  }

  @action
  removeRefinement() {
    this.args.condition.set('refinement', null);
  }
}
